export function timeoutMessage(isReport = false) {
  return isReport
    ? 'İşlem süre aşımına uğradı. Rapor aralığınızı daraltınız ve tekrar deneyiniz.'
    : 'İşlem süre aşımına uğradı. Lütfen tekrar deneyiniz.';
}
